import React, {Component} from 'react';
import * as firebase from 'firebase';
import MetaTags from 'react-meta-tags';
import 'react-quill/dist/quill.snow.css';

export default class EditFaqPost extends Component {
  constructor() {
    super();
    this.state = {
      title: '',
      info: '',
      showRemoveBox: false
    }
    this.handleChangeTitle = this.handleChangeTitle.bind(this);
    this.handleChangeInfo = this.handleChangeInfo.bind(this);
    this.handleRemoveBox = this.handleRemoveBox.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleSave = this.handleSave.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0,0)
    let id = this.props.match.params.id;
    const EditFaqRef = firebase.database().ref('faq/').orderByChild('id').equalTo(id);
    EditFaqRef.on('value', snap => {
      snap.forEach((child) => {
         this.setState({
            title: child.val().title,
            info: child.val().info,
            id: child.val().id,
            userId: child.val().userId,
            createDate: child.val().createDate,
            createTime: child.val().createTime
         })
      })
    })
  }

  handleChangeTitle(event) {
    this.setState({title: event.target.value})
  }
  handleChangeInfo(event) {
    this.setState({info: event.target.value})
  }
  handleRemoveBox() {
    this.setState({
        showRemoveBox: true
    })  
  }
  handleRemove(event) {
    event.preventDefault()
    let id = this.props.match.params.id;
    const removeRef = firebase.database().ref('faq/').child(id);
    removeRef.remove();
    window.location = ('/UserProfile/myFaqTable');
  }
  handleCancel() {
    this.setState({
      showRemoveBox: false
    })  
  }
  handleSave(event, value) {
    let id = this.props.match.params.id;
    const postRef = firebase.database().ref('faq/').child(id)

    postRef.update({
      title: this.state.title,
      info: this.state.info,
      createDate: new Date().toLocaleDateString(),
      createTime: new Date().toLocaleTimeString()
    })
    window.location = ('/UserProfile/myFaqTable');
  }

  render() {
    return(
      <div>
        <MetaTags>
            <title>草學藥事 || 修改問題</title>
            <meta id="og-title" property="og:title" content="修改問題" />
        </MetaTags>
       <h1>修改發問問題</h1>
       <div className="postForm">
       <form onSubmit={this.handleSave} style={{position: 'relative'}} >
        <div className="container-fluid">
         <div className="row paddLeftAuto">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 paddLeftAuto">
           <div className="group">
            <label htmlFor="title">*問題標題:</label>
            <input type="text" id="title" value={this.state.title} onChange={this.handleChangeTitle} required="true" placeholder="我常常胸悶~" />
           </div>
           <div className="group">
            <label htmlFor="info">*問題描述:</label>
            <textarea id="info" value={this.state.info} onChange={this.handleChangeInfo} style={{padding: 7}} required="true" placeholder="想問什麼就問吧"></textarea>
           </div>

          </div>
         </div>
        </div>
        <input type="submit" value="送出" className="btnDefault" />
        <input type="button" value="刪除" className="btnDefault" onClick={this.handleRemoveBox} />
        <div style={{display: this.state.showRemoveBox ? 'block' : 'none', position: 'absolute', bottom: '15%', left: 0, background: '#fff', padding: '15px 30px', boxShadow: '0 0 3px rgba(0,0,0,.6)', borderRadius: 7}} >
          <a onClick={this.handleRemove} style={{margin: '0 10px', color: '#dcdcdd'}} >確認刪除</a>
          <a onClick={this.handleCancel} style={{margin: '0 10px'}} >取消</a>
        </div>
       </form>
       </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/post/EditFaqPost.js